import cn from 'classnames';
import close from '@packages/shared/assets/cross.svg';
import arrowBack from '@packages/shared/assets/arrow-forward.svg';
import Modal from '@packages/shared/core/common/components/common/Modal';
import Image from '@packages/shared/core/common/components/common/Image';
import Button from '@packages/shared/core/common/components/common/Button';
import styles from './ChatModal.module.scss';

type ChatModalProps = {
  isOpen: boolean;
  onBack: () => void;
  onContinue: () => void;
};

export const ChatModal = ({ isOpen, onBack, onContinue }: ChatModalProps) => {
  return (
    <Modal open={isOpen} onClose={onContinue}>
      <div className={styles.root}>
        <Image className={styles.close} src={close} type="future" alt="close" width={21} height={21} />

        <p className={styles.text}>
          {`To continue chat with the psychic you need to create an account. `}

          <span className={styles.mobileText}>Tap</span>

          <span className={styles.desktopText}>Click</span>

          {` “Continue” to proceed.`}
        </p>

        <ul className={styles.buttonList}>
          <li className={styles.buttonListItem}>
            <Button
              wrapperClassName={styles.buttonWrapper}
              className={cn(styles.button, styles.buttonBack)}
              variant="outlined"
              onClick={onBack}
            >
              <Image type="future" className={styles.arrow} src={arrowBack} height={16} width={16} alt="arrow back" />
            </Button>
          </li>

          <li className={styles.buttonListItem}>
            <Button onClick={onContinue} className={styles.button} wrapperClassName={styles.buttonWrapper}>
              Continue
            </Button>
          </li>
        </ul>
      </div>
    </Modal>
  );
};

export default ChatModal;
